
import componentTitleFr from '../../_components/componentTitleFr.vue'
import {useStore} from "@/store";
import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";
interface State {
    configInfo: object[];
    baseInfo:  object[];
    photoList:  object[];
    templateCode: string;
}
export default defineComponent({
        name: "promiseFrame",
        setup() {
            let state: State = reactive({
                configInfo: [],
                baseInfo: [],
                photoList: [],
                templateCode: ''
            })
            window.scrollTo(0,0);
            // let carInfo = localStorage.getItem('carInfo') || '';
            // console.log(carInfo);
            // state.configInfo = JSON.parse(carInfo).configureInfos;
            // state.baseInfo = JSON.parse(carInfo).basicItemInfos;
            let store = useStore()
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            watch(reportData, (data: any) => {
                const {componentList} = JSON.parse(JSON.stringify(data));
                const baseInfo = componentList.find(item => item.code === 'baseInfo');
                const configInfo = componentList.find(item => item.code === 'configInfo');
                state.baseInfo = baseInfo && baseInfo.configItems;
                state.configInfo = configInfo && configInfo.configItems;
            }, {immediate: true, deep: true})
            return {
                state
            }
        },
        components: {
            componentTitleFr
        },
        beforeUnmount () {
            localStorage.removeItem('carInfo');
        },
    })
